import "./recordDrawer.css";

/**
 * One header for every record drawer in the backoffice.
 *
 * Screens had each grown their own: a grey kicker ("MATCHING QUEUE · JOB
 * DETAIL"), a generic title that restated the screen you were already on
 * ("รายละเอียดงานพร้อม Matching"), and the record's actual name buried a
 * section further down. Worker Profiles had already fixed this for itself -
 * name first, code under it, status beside it - and the owner asked for that
 * one treatment everywhere ("ให้ใช้การแสดงผลแบบเดียวกันทั้งแอฟสิครับ").
 *
 * So it is a component, not a convention: the layout, the tab underline and
 * the spacing now live in one place, and a screen supplies only what is genuinely
 * different about its record - who it is, its code, its badges, its tabs.
 */

/** Two-letter monogram from a name - never a fabricated logo or photo. */
export function monogramOf(name) {
  const trimmed = (name ?? "").trim();
  if (!trimmed) {
    return "-";
  }
  const parts = trimmed.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export default function RecordDrawerHeader({ titleId, title, subtitle, avatarText, badges = [], tabs = [], activeTab, onTabChange }) {
  const realBadges = badges.filter(Boolean);
  return (
    <>
      <div className="wx-rdh-ident">
        {avatarText !== undefined && (
          <span className="wx-rdh-avatar" aria-hidden="true">
            {monogramOf(avatarText)}
          </span>
        )}
        <div className="wx-rdh-ident-text">
          <h2 id={titleId} className="wx-rdh-title">
            {title}
          </h2>
          {subtitle && <p className="wx-rdh-sub">{subtitle}</p>}
        </div>
      </div>

      {realBadges.length > 0 && (
        <div className="wx-rdh-status">
          {realBadges.map((badge) => (
            <span key={badge.label} className={`wx-badge wx-badge--${badge.variant ?? "neutral"}`}>
              {badge.label}
            </span>
          ))}
        </div>
      )}

      {tabs.length > 0 && (
        <div className="wx-rdh-tabs">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              type="button"
              className={`wx-rdh-tab${activeTab === tab.key ? " wx-rdh-tab--active" : ""}`}
              aria-current={activeTab === tab.key ? "true" : undefined}
              onClick={() => onTabChange(tab.key)}
            >
              {tab.label}
            </button>
          ))}
        </div>
      )}
    </>
  );
}
